import type { Components } from '@mui/material/styles';

export default function MUIAccordionActions(): Components['MuiAccordionActions'] {
  return {};
}
